module.exports = __webpack_public_path__ + "img/en_tis_uninstall7.3a524022.png";